var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9922 11.9235C13.0994 11.9935 13.2101 12.0409 13.288 12.1188C14.7391 13.5631 16.1913 15.0074 17.6277 16.4653C17.796 16.6358 17.9303 16.8797 17.9834 17.1112C18.0444 17.38 17.9349 17.6487 17.6921 17.8249C17.4098 18.0304 17.1037 18.07 16.7932 17.9006C16.6645 17.8294 16.547 17.7278 16.442 17.6228C14.9921 16.1773 13.5444 14.7296 12.0978 13.2808C12.0255 13.2086 11.9736 13.116 11.9024 13.02C9.97595 14.4925 7.87104 14.9295 5.58319 14.4146C3.89835 14.0352 2.54213 13.1081 1.49306 11.7451C-0.786882 8.78191 -0.380354 4.57322 2.19884 2.09566C4.87854 -0.479022 8.88058 -0.719551 11.8426 1.58637C13.4213 2.81611 14.3495 4.4682 14.5652 6.46922C14.7798 8.4533 14.2998 10.2669 12.9922 11.9235ZM12.9538 7.32971C12.9628 4.2096 10.4548 1.68913 7.32787 1.67558C4.21229 1.66203 1.68165 4.17234 1.66358 7.29357C1.64664 10.4193 4.17276 12.9579 7.30529 12.9601C10.4322 12.9624 12.9447 10.4577 12.9538 7.32971Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8ffe818856bf5076dd05ab3375354845.svg";
export { ForwardRef as ReactComponent };